import React, { useEffect } from 'react'
import LogoIcon from '../images/logo-circle.svg'
import classNames from 'classnames'
import { getMenuLinks } from '~helpers/constant'
import { Link, useLocation } from 'react-router-dom'
import BurgerMenu from './burger-menu'
import ym from 'react-yandex-metrika'
import { AmplitudeCounter } from "~/amplitude-counter";
import Select from 'react-select';
import { ICountryCode, phoneNumsLib } from "~/components/pages/partners/constans";
// import { NewYearHeader } from './new-year-header'
import { countrySlice } from "~/store/reducers/CountrySlice";
import { useAppDispatch, useAppSelector } from "~/hooks/redux";
import { ICountryItem } from "~/types/ICountryItem";

interface ICountryLib {
  [key: string]: ICountryItem;
}

const options: ICountryItem[] = [
  { value: 'RU', label: 'Россия', currency: 'RUB'},
  { value: 'UZ', label: 'Узбекистан', currency: 'UZS' },
  { value: 'KZ', label: 'Казахстан', currency: 'KZT' }
]

const countryLib: ICountryLib = {
  KZT: { value: 'KZ', label: 'Казахстан', currency: 'KZT' },
  UZS: { value: 'UZ', label: 'Узбекистан', currency: 'UZS' },
  RUB: { value: 'RU', label: 'Россия', currency: 'RUB' }
};

export const Menu: React.FC = () => {
  const [isActive, setActive] = React.useState<boolean>(false)

  const isServer = typeof window === 'undefined'

  const { country } = useAppSelector(state => state.countryReducer)
  const { changeCountry } = countrySlice.actions
  const dispatch = useAppDispatch()

  let localStorageCountry: ICountryItem | null = null

  if (!isServer) {
    const localStorageCountryValue: string = window?.localStorage?.getItem('country') || ''
    if (localStorageCountryValue && !localStorageCountryValue?.includes('undefined')) {
      try {
        localStorageCountry = JSON.parse(localStorageCountryValue)
      } catch (ignore) {
        localStorageCountry = null
      }
    }
  }

  const useQuery = () => new URLSearchParams(useLocation().search);
  const query = useQuery();
  const selectedCurrency = query.get('currency')?.toUpperCase()

  useEffect(() => {
    if (selectedCurrency && countryLib[selectedCurrency]) {
      dispatch(changeCountry(countryLib[selectedCurrency]))
    } else if (localStorageCountry !== null) {
      dispatch(changeCountry(localStorageCountry))
    }
  },[selectedCurrency]);

  const location = useLocation();
  const isPartner = (process.env.IS_BROWSER + '') === 'true' && window.location.pathname === '/partners';

  const selectedCountryValue: ICountryCode = country?.value;

  const getPhone = () => {
    return phoneNumsLib[selectedCountryValue] || phoneNumsLib.RU
  }

  const getPhoneLink = (phone: string) => {
    return phone.replace(/\D/g, '')
  }

  const trackCountrySelection = (country: string ) => {
    ym('reachGoal', `${'site_' + country}`, 631388);
    AmplitudeCounter('select_country', {'chosen_country': country, 'country_site': country})
  }

  useEffect(() => {
    if (!isServer) {
      window.localStorage.setItem('country', JSON.stringify(country))
    }
  }, [country])

  const getLink = () => {
    switch (process.env.SERVER_NODE_ENV) {
      case 'production':
        if (isPartner) return 'https://partners.onlinepbx.ru'
        return 'https://panel.onlinepbx.ru'
      case 'development':
        if (isPartner) return 'https://partners.test.onlinepbx.ru'
        return 'https://panel.test.onlinepbx.ru'
      case 'stage':
        if (isPartner) return 'https://partners.stage.onlinepbx.ru'
        return 'https://panel.stage.onlinepbx.ru'
    }
  }

  const links = getMenuLinks()
  const link = getLink()
  const getUtms = (): any => {
    const utmMedium = document.cookie.replace(/(?:(?:^|.*;\s*)utm_medium\s*=\s*([^;]*).*$)|^.*$/, '$1')
    const utmSource = document.cookie.replace(/(?:(?:^|.*;\s*)utm_source\s*=\s*([^;]*).*$)|^.*$/, '$1')
    const utmCampaign = document.cookie.replace(/(?:(?:^|.*;\s*)utm_campaign\s*=\s*([^;]*).*$)|^.*$/, '$1')
    const utmTerm = document.cookie.replace(/(?:(?:^|.*;\s*)utm_term\s*=\s*([^;]*).*$)|^.*$/, '$1')
    const utmContent = document.cookie.replace(/(?:(?:^|.*;\s*)utm_content\s*=\s*([^;]*).*$)|^.*$/, '$1')
    const partnerId = document.cookie.replace(/(?:(?:^|.*;\s*)partnerId\s*=\s*([^;]*).*$)|^.*$/, '$1')
    return {
      utmMedium,
      utmSource,
      utmCampaign,
      utmTerm,
      utmContent,
      partnerId
    }
  }
  const handleActiveScroll = () => {
    setActive(window.scrollY > 0)
  }

  const handleRedirect = () => {
    const utms = getUtms()

    const partnerId = document.cookie.replace(/(?:(?:^|.*;\s*)partnerId\s*=\s*([^;]*).*$)|^.*$/, '$1')
    const promo = document.cookie.replace(/(?:(?:^|.*;\s*)promo\s*=\s*([^;]*).*$)|^.*$/, '$1')

    const query = Object.keys(utms).map(utm => {
      if (!utms[utm]) return
      return `${utm}=${utms[utm]}`
    }).filter(utm => utm).join('&')
    ym('reachGoal', 'lead', { url: window.location.href })
    AmplitudeCounter('click_registration', { 'name_button': 'Регистрация', 'page_name': 'Шапка сайта' })
    AmplitudeCounter('click_registration', { 'country_site': country?.value.toLowerCase()})
    const url = query ? new window.URL(`${link}/register/?${query}`) : new window.URL(`${link}/register`)
    !!partnerId && url.searchParams.append('partnerId', partnerId)
    !!promo && url.searchParams.append('promo', promo)

    window.open(url.toString(), '_blank')
  }


  React.useEffect(() => {
    window.addEventListener('scroll', handleActiveScroll)
    return () => {
      window.removeEventListener('scroll', handleActiveScroll)
    }
  })

  const customStyles = {
    option: (defaultStyles: any, state: any) => ({
      ...defaultStyles,
      color: "#4E4963",
      fontSize: '14px',
      lineHeight: '22px',
      fontWeight: state.isSelected ? "600" : '400',
      backgroundColor: state.isSelected ? "#fff" : "#fff",
      border: "none",
      cursor: "pointer"
}),

    control: (defaultStyles: any, state: any) => ({
      ...defaultStyles,
      backgroundColor: state.isFocused ? "#EFEEF5" : "#fff",
      border: "none",
      boxShadow: "none",
      color: "#4E4963",
      fontSize: '14px',
      fontWeight: '400',
      lineHeight: '22px',
      cursor: "pointer"
    }),

    dropdownIndicator: (defaultStyles: any) => ({ ...defaultStyles, color: "#4E4963", padding: 0, paddingRight: '6px' }),
    indicatorSeparator: (defaultStyles: any) => ({ ...defaultStyles, display: "none" }),
  };

  return (
    <div className={classNames('onlinepbx__menu__wrapper', {
      'onlinepbx__menu__wrapper__active': isActive
    })}>
      {/* <NewYearHeader /> */}
      <div className='onlinepbx__block__menu'>
        <div className='onlinepbx__menu'>
          <div className="onlinepbx__menu__top">
            <div className='onlinepbx__menu__left'>
              <Link
                to='/'
                className='onlinepbx__menu__logo'>
                <LogoIcon className='onlinepbx__menu__logo__icon' />
              </Link>
              <div className='onlinepbx__menu__select'>
                <Select
                  styles={customStyles}
                  value={country}
                  onChange={(selectedOption) => {
                    dispatch(changeCountry(selectedOption));
                    trackCountrySelection(selectedOption.value.toLowerCase());
                  }}
                  options={options}
                />
              </div>
            </div>
            <div className="onlinepbx__menu__phones">
              <a
                href={`tel:+${getPhoneLink(getPhone().sd)}`}
                className='onlinepbx__menu__phone__link'>
                {getPhone().sd} Отдел продаж
              </a>
              <a
                href={`tel:+${getPhoneLink(getPhone().ts)}`}
                className='onlinepbx__menu__phone__link'>
                {getPhone().ts} Техподдержка
              </a>
            </div>
            <div className='onlinepbx__menu__right'>
              <BurgerMenu
                onClick={handleRedirect}
                link={link}
                phone={{text: getPhone().sd, value: getPhoneLink(getPhone().sd)}}
              />
              <div className='onlinepbx__menu__right__content'>
                <button
                  onClick={() => window.open(`${link}/login`, '_blank')}
                  className='onlinepbx__menu__button__border'>
                  {isPartner ? 'Вход для партнеров' : 'Вход'}
                </button>
                {!isPartner && <button
                  onClick={handleRedirect}
                  className='onlinepbx__menu__button__fill'>
                  Регистрация
                </button>}
              </div>
            </div>
          </div>
          <div className="onlinepbx__menu__links__wrapper">
            <div className='onlinepbx__menu__links'>
              {
                links.map((link, index) => <Link
                  key={link.route || index}
                  className={classNames('onlinepbx__menu__link', {
                    'onlinepbx__menu__link__active': link.route === location.pathname,
                    'onlinepbx__menu__link__have__sublinks': link?.links?.length
                  })}
                  to={link.route}
                  >
                  {link.name}
                  {
                    link.links && 
                    (
                      <div className="onlinepbx__menu__sublinks">
                        <div className="onlinepbx__menu__sublinks__wrapper">
                          {
                            link.links.map(sublink => (
                              <Link
                                key={sublink.route}
                                to={sublink.route}
                                className={classNames('onlinepbx__menu__sublink', {
                                  'onlinepbx__menu__sublink__active': sublink.route === location.pathname
                                })}
                              >
                                {sublink.name}
                              </Link>
                            ))
                          }
                        </div>
                      </div>
                    )
                  }
                </Link>)
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Menu
